<template>
    <Teleport to="main">
        <div class="pp-ticket-check-results">
            <PpTicketCheckResultsSummary />
            <PpTicketCheckResultsDetail />
        </div>
    </Teleport>
</template>

<script lang="ts" setup>
import { computed, onMounted } from "vue";
import PpTicketCheckResultsSummary from "./pp-ticket-check-results-summary.vue";
import PpTicketCheckResultsDetail from "./pp-ticket-check-results-detail.vue";
import { usePpTicketCheck } from "../../composables/use-ticket-check";
import { ProductPageAnalytics } from "../../analytics/analytics-product-page";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";

const { ticketCheckResult } = usePpTicketCheck();
const { config } = usePpWagerConfiguration();

const analyticsResult = computed(() => (ticketCheckResult.value.winAmount > 0 ? "win" : "loss"));
ProductPageAnalytics.pushTicketCheckResult(analyticsResult.value, config.lottery);

onMounted(() => {
    const container = document.getElementById("pp-check-and-results");
    if (container) {
        container.style.display = "none";
    }
    const carousel = document.getElementById("pp-quick-wager-carousel");
    if (carousel) {
        carousel.style.display = "none";
    }

    document.body.classList.add("theme--ticket-check-results");

    window.scrollTo(0, 1);
});
</script>
